import { __read, __spread } from "tslib";
import React from "react";
import classNames from "classnames";
import { mergeStyle } from "../../_util/merge-style";
export function stylize(_a) {
    var className = _a.className, style = _a.style, headClassName = _a.headClassName, headStyle = _a.headStyle, bodyClassName = _a.bodyClassName, bodyStyle = _a.bodyStyle;
    var addon = { getInfo: function () { return ({ name: "stylize" }); } };
    if (className || style) {
        addon.onInjectTable = withStyle(className, style);
    }
    if (headClassName || headStyle) {
        addon.onInjectHead = withStyle(headClassName, headStyle);
    }
    if (bodyClassName || bodyStyle) {
        addon.onInjectBody = withStyle(bodyClassName, bodyStyle);
    }
    return addon;
}
function withStyle(className, style) {
    return function (render) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var element = render.apply(void 0, __spread(args));
        var elementProps = element.props;
        return React.cloneElement(element, {
            className: classNames(elementProps.className, className),
            style: mergeStyle(elementProps.style, style),
        });
    }; };
}
//# sourceMappingURL=stylize.js.map